const PREFIX = '/events';
const PATH_MAP = {
    '/g/collect': '/v1/a'
};
function isAlreadyEncoded(search) {
    if (typeof URLSearchParams !== 'undefined') {
        const params = new URLSearchParams(search);
        return params.size === 1 && params.has('q');
    }
    return search.startsWith('?q=') && search.indexOf('&') === -1;
}
function getBtoa(btoaFn) {
    if (btoaFn === null) {
        return null;
    }
    if (typeof btoaFn === 'function') {
        return btoaFn;
    }
    if (typeof btoa === 'function') {
        return btoa;
    }
    return null;
}
function toBase64Url(value, btoaFn) {
    const encode = getBtoa(btoaFn);
    if (!encode) {
        throw new Error('btoa unavailable');
    }
    return encode(value)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}
export function rewriteSgtmUrl(raw, baseHref, btoaFn) {
    try {
        const baseOrigin = new URL(baseHref).origin;
        const url = new URL(raw, baseHref);
        if (url.origin !== baseOrigin) {
            return raw;
        }
        if (!url.pathname.startsWith(PREFIX + '/')) {
            return raw;
        }
        const mapped = PATH_MAP[url.pathname.slice(PREFIX.length)];
        if (!mapped) {
            return raw;
        }
        const originalSearch = url.search.slice(1);
        url.pathname = PREFIX + mapped;
        if (originalSearch) {
            const encode = getBtoa(btoaFn);
            if (encode && isAlreadyEncoded(url.search)) {
                return url.toString();
            }
            if (encode) {
                try {
                    url.search = '?q=' + toBase64Url(originalSearch, btoaFn);
                }
                catch (_a) {
                    url.search = '?' + originalSearch;
                }
            }
            else {
                url.search = '?' + originalSearch;
            }
        }
        return url.toString();
    }
    catch (_b) {
        return raw;
    }
}
// sGTM server must decode ?q= from base64url and restore query params before forwarding to GA.
// When q is absent (no btoa / older browsers), forward query params as-is.
export default function installSgtmPathRewrite() {
    try {
        const w = window;
        if (w.__sgtmPathRewrite)
            return;
        const baseHref = window.location.href;
        const rewriteUrl = (raw) => rewriteSgtmUrl(raw, baseHref);
        const origFetch = window.fetch;
        if (typeof origFetch === 'function') {
            window.fetch = function (input, init) {
                try {
                    if (typeof input === 'string' || (typeof URL === 'function' && input instanceof URL)) {
                        return origFetch.call(this, rewriteUrl(String(input)), init);
                    }
                    if (typeof Request === 'function' && input instanceof Request) {
                        const rewritten = rewriteUrl(input.url);
                        if (rewritten !== input.url) {
                            return origFetch.call(this, new Request(rewritten, input), init);
                        }
                    }
                }
                catch (_a) {
                    // fail open
                }
                return origFetch.call(this, input, init);
            };
        }
        if (typeof XMLHttpRequest !== 'undefined' && XMLHttpRequest.prototype) {
            const origOpen = XMLHttpRequest.prototype.open;
            XMLHttpRequest.prototype.open = function (method, url, ...rest) {
                try {
                    return origOpen.call(this, method, rewriteUrl(String(url)), ...rest);
                }
                catch (_a) {
                    return origOpen.call(this, method, url, ...rest);
                }
            };
        }
        if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
            const origBeacon = navigator.sendBeacon;
            navigator.sendBeacon = function (url, data) {
                try {
                    return origBeacon.call(navigator, rewriteUrl(String(url)), data);
                }
                catch (_a) {
                    return origBeacon.call(navigator, url, data);
                }
            };
        }
        try {
            const srcDesc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
            if (srcDesc && srcDesc.set) {
                Object.defineProperty(HTMLImageElement.prototype, 'src', {
                    configurable: true,
                    enumerable: srcDesc.enumerable,
                    get: srcDesc.get,
                    set(value) {
                        try {
                            srcDesc.set.call(this, rewriteUrl(String(value)));
                        }
                        catch (_a) {
                            srcDesc.set.call(this, value);
                        }
                    }
                });
            }
        }
        catch (_a) {
            // skip img.src patch
        }
        try {
            const origSetAttribute = Element.prototype.setAttribute;
            Element.prototype.setAttribute = function (name, value) {
                try {
                    if (typeof HTMLImageElement !== 'undefined' && this instanceof HTMLImageElement && name.toLowerCase() === 'src') {
                        return origSetAttribute.call(this, name, rewriteUrl(String(value)));
                    }
                }
                catch (_a) {
                    // fail open
                }
                return origSetAttribute.call(this, name, value);
            };
        }
        catch (_b) {
            // skip setAttribute patch
        }
        w.__sgtmPathRewrite = true;
    }
    catch (_c) {
        // silent — page continues without rewrite
    }
}
